import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type BoolColumnProps = {
  value: boolean;
};

export const BoolColumn = (props: BoolColumnProps) => {
  return props.value ? (
    <CheckCircleIcon color='success' />
  ) : (
    <CancelIcon color='error' />
  );
};
